import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';
import { useContractForRender } from './useContractForRender';

/** @category Contracts */
export function useContract(contractId, profileId, alwaysLoad = true) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const specificContractQueryResult = useQuery({
    ...tokenizedApi.contracts.contractQuery({ profileId, contractId }),
    // Since contracts contain editable data (drafts), we want to
    // reload every time the hook’s component mounts
    refetchOnMount: alwaysLoad ? 'always' : true,
  });

  // Falling back to the list query result prevents an unnecessary
  // spinner while the specific query loads, if we actually have the data already
  const allContractsQueryResult = useQuery({
    ...tokenizedApi.contracts.contractsQuery({ profileId }),
    staleTime: Infinity,
    select: (contracts) => contracts?.idMap?.get?.(contractId),
  });
  // Fall back to the event from the whole list only if
  // we have no successful response from the specific query,
  // and the list query has been successful
  let contractQueryResult = specificContractQueryResult;
  if (
    allContractsQueryResult?.isSuccess &&
    !specificContractQueryResult?.isSuccess
  ) {
    contractQueryResult = allContractsQueryResult;
  }

  const preparedContract = useContractForRender(
    contractQueryResult?.data,
    profileId,
  );

  return (
    contractQueryResult && {
      ...contractQueryResult,
      data: preparedContract,
    }
  );
}
